import { render } from "./AppInputTextarea.vue?vue&type=template&id=ad37d0ae&scoped=true&ts=true&lang=pug"
import script from "./AppInputTextarea.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppInputTextarea.vue?vue&type=script&lang=ts&setup=true"

import "./AppInputTextarea.vue?vue&type=style&index=0&id=ad37d0ae&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad37d0ae"]])

export default __exports__